<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "MenuAdd",
        data() {
            return {

            };
        },
        mounted(){

        },
        methods: {

        }
    }
</script>

<style scoped>
.box{display: block;width: 60%;margin: 0 auto;}
.input_box{display: block;width: 100%}
.hrefa{color: #1890ff;display: inline-block;margin-right: 5px}
</style>